import React from 'react'

import styles from './StatusController.module.sass'
import { useFetchList } from 'store'
import PodStatus from 'models/PodStatus'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import PodInfo from 'components/PodInfo/PodInfo'

const TableHeadItem = ({ label }) => {
	return (
		<th scope='col' className={styles['table-header-cell']}>
			{label}
		</th>
	)
}

const StatusController = () => {
	const { i18n } = useGlobal()
	const { state, contents } = useFetchList(['/status'], [PodStatus.fromJSON])
	const isLoading = state === 'loading'
	const [pods = []] = contents || []

	return (
		<>
			<Widget
				paddings={['small', 'normal']}
				className={styles['header-container']}
				applyMaxWidth
			>
				<h2 className={styles['welcome-title']}>{i18n`Status`}</h2>
			</Widget>
			<Widget
				paddings={['', 'normal', 'large']}
				className={styles['header-container']}
				applyMaxWidth
			>
				{isLoading ? (
					<h4>{i18n`Loading`}...</h4>
				) : (pods ?? []).length > 0 ? (
					<div className={styles['table-wrapper']}>
						<table className={styles['table']}>
							<thead className={styles['table-header']}>
								<TableHeadItem label={i18n`Service`} />
								<TableHeadItem label={i18n`Age`} />
								<TableHeadItem label={i18n`Status`} />
								<TableHeadItem
									label={i18n`Alerts (last 30 minutes)`}
								/>
							</thead>
							<tbody className={styles['table-body']}>
								{pods.map((pod) => (
									<PodInfo key={pod.name} pod={pod} />
								))}
							</tbody>
						</table>
					</div>
				) : (
					<h3>{i18n`Error communicating with API`}...</h3>
				)}
			</Widget>
		</>
	)
}

export default StatusController
